//convert binary to base64
const getBase64DataFromBinary = (file) => {
  return window.URL.createObjectURL(file);
};


export { getBase64DataFromBinary };
